'use strict';

angular.module('selfAccessRequestControllers')

.controller('AdHocRemoveRightsExplanationController',
            ['$scope', '$stateParams', '$translate', 'topBar', '$modal', '$state', '$timeout', 'selfAccessRequestService', 'selfAccessRequest', 'processStep',
function ($scope, $stateParams, $translate, topBar, $modal, $state, $timeout, selfAccessRequestService, selfAccessRequest, processStep) {

    // Load translation asynchronously to avoid race condition
    $translate('iam.selfAccessRequest.adHoc.pageTitle').then(function(translation) {
        topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                            '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-shopping-cart');
    });

    $scope.selfAccessRequest = selfAccessRequest;

    // $scope.currentUserId = selfAccessRequest.EmployeeID;
    selfAccessRequestService.getProcessStepStatusListForSelfAccessRequest($stateParams.userAccessRequestId)
     .then(function (processStepStatusList) {
         $scope.processStepStatusList = processStepStatusList;
     });

    // Go To RemoveRights
    $scope.goToRemoveRights = function () {

        // InProgress/Completed - Go to Decisions
        if (processStep.IsInProgress || processStep.IsCompleted) {
            $state.go('selfAccessRequest.adHoc.additionalSteps');
            return;
        }

        // Skipped - Do nothing
        if (processStep.IsSkipped) return;

        $scope.isLoadingRemoveRights = true;

        selfAccessRequestService
            .createRemoveRightsDecisions($stateParams.userAccessRequestId)
            .then(function (removeRightsDecisions) {
                $scope.isLoadingRemoveRights = false;

                if (_.isUndefined(removeRightsDecisions.NoDataReason)) {
                    $state.go('selfAccessRequest.adHoc.additionalSteps');
                    return;
                }

                var modalScope = $scope.$new(true);
                modalScope.NoDataReason = removeRightsDecisions.NoDataReason;
                var noDecisionsModal = $modal({
                    scope: modalScope,
                    template: require('./NoDecisionsModal.tpl.html'),
                    placement: 'center'
                });

                modalScope.hideModal = function () {
                    noDecisionsModal.$promise.then(noDecisionsModal.hide);
                };

                modalScope.okModal = function () {
                    modalScope.hideModal();
                };

                modalScope.skipRemoveRightsStep = function () {
                    selfAccessRequestService
                        .skipProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'RemoveRights')
                        .then(function (selfAccessRequest) {
                            modalScope.hideModal();
                            $state.go(selfAccessRequest.SelfRequestPageRoute, { }, {reload:true
                        });
                     });
                }

            });
    }

    // Skip Step
    $scope.skipStep = function (event, step) {
        event.stopPropagation();
        selfAccessRequestService.skipProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, step)
         .then(function (selfAccessRequest) {
             $state.go(selfAccessRequest.SelfRequestPageRoute, {}, { reload: true });
         });
    }

}]);
